// Branding Configuration
// Change ACTIVE_BRAND to switch between different white-label brands

export const BRANDING = {
  ALH_GROUP: {
    name: 'ALH Group',
    displayName: 'ALH Group',
    templateId: '4GirEL1WcY-vA1gN_0q8s',
    logo: 'https://images.squarespace-cdn.com/content/v1/588abde35016e12082207796/05fba812-6d68-4b9f-9353-c1a5ee5feb1e/ALH_Group_Logo_Transparent.png',
    colors: {
      primary: '#003263',
      secondary: '#f6cd59',
      primaryHover: '#004080',
      secondaryHover: '#e5bc48'
    },
    links: {
      website: 'https://www.alhgroup.com.au/',
      contact: 'https://www.alhgroup.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      email: 'demo@idvpacific.com.au',
      membershipNo: String(Math.floor(Math.random() * 900000) + 100000),
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || ''
    })
  },
  
  MAX_GAMING: {
    name: 'MAX_GAMING',
    displayName: 'MAX Gaming',
    templateId: '2K14v1NQaGwyFVEbpyphh',
    logo: 'https://max.com.au/wp-content/uploads/2023/05/MAX-logo.png',
    colors: {
      primary: '#5B3A7D',
      secondary: '#E63946',
      primaryHover: '#7B5A9D',
      secondaryHover: '#D62839'
    },
    links: {
      website: 'https://max.com.au/',
      contact: 'https://max.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: 'demo@idvpacific.com.au',
      phone: '+611234567890',
      memberId: Math.floor(Math.random() * 900000) + 100000,
      pointsKey: 1000,
      membershipType: 'VIP Member'
    })
  },
  
  IDV_PACIFIC: {
    name: 'IDV_PACIFIC',
    displayName: 'IDV Pacific',
    templateId: 'eyaEuEx6TO02LOb5rFx-o',
    logo: 'https://idvpacific.com.au/wp-content/uploads/2018/09/IVD-Logo-retina.png',
    colors: {
      primary: '#0066CC',
      secondary: '#006abc',
      primaryHover: '#0052a3',
      secondaryHover: '#005599'
    },
    links: {
      website: 'https://idvpacific.com.au/',
      contact: 'https://idvpacific.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: documentData.email || 'demo@idvpacific.com.au',
      dateOfBirth: documentData.dateOfBirth || new Date().toISOString()
    })
  }
};

// ========================================
// CHANGE THIS TO SWITCH BRANDS IDV_PACIFIC ALH_GROUP MAX_GAMING    
// ========================================
export const ACTIVE_BRAND = BRANDING.IDV_PACIFIC;

// Helper function to build the complete card request
export const buildDigitalCardRequest = (documentData) => ({
  templateId: ACTIVE_BRAND.templateId,
  cardPayload: ACTIVE_BRAND.buildCardPayload(documentData),
  options: {
    downloadId: null,
    emailInvitationEnabled: true,
    smsInvitationEnabled: false
  }
});
